import type { FaireProductEntity } from "../../entity_types/product";

export const p_sbrvtrymz9: FaireProductEntity = {
  token: "p_sbrvtrymz9",
  type: "product",
  name: "Calder Sweater Tee - Dusk (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/4f9d1aa9f156ef74a1146d007a9e221f715e2c698df99e71f629a810d857e4a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f419af9aa73c6ad730bcb3f0730af31604c3fd5c859f2898a2a1d9ae2f86289.jpeg",
    "https://cdn.faire.com/fastly/414708a2c6efd16e8cfdfdba38a38b641f2634da0cd1eadb7dd1a0b7ab82ca41.jpeg",
    "https://cdn.faire.com/fastly/eb58ef0875d6849e0f39f2ded831c8308ec0fbeb4d2d5ebd3a8b3d122cff6de7.jpeg",
    "https://cdn.faire.com/fastly/4ad366df17410578416fb26fb0d8d181446cb7b60ebb89eb99d0cebbb0f88424.jpeg",
    "https://cdn.faire.com/fastly/e4d22094beb63b6e6749b441a79da2704b8f67e90b1ae44c5c919e380ab9a156.jpeg",
    "https://cdn.faire.com/fastly/985e07d9f0ec2e5a1bf4255c701ec90b40600dcec6a27c38ea2db196135bf636.jpeg",
    "https://cdn.faire.com/fastly/dd28da79a17b030d08186011c9c87f8b0cc65a75c985c611f5a18fcf42bad6f9.jpeg",
    "https://cdn.faire.com/fastly/aff115f54d9c190333ebd321a77d411e9fe3387813d74e637a0946bdbbd1f6ee.jpeg",
    "https://cdn.faire.com/fastly/eb0114c08cf2be40ea17d8c84ecb20ff8183f9671286228bee4e7582bd41c692.jpeg"
  ],
  priceDollars: 75.6,
  description: "A new knitted interpretation in our best-selling boxy sweater tee body. The Calder has a bold geometric pattern that takes inspiration from Calder’s legendary Mobiles and features a contrast trim neckline and oversized drop shoulder silhouette.\n\n\n * Boxy body, drop shoulder \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:29.419Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
